/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Subtitle_Export_Failed_ToastInputs */

const en_subtitle_export_failed_toast = /** @type {(inputs: Subtitle_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subtitle export failed: ${i?.error}`)
};

const fr_subtitle_export_failed_toast = /** @type {(inputs: Subtitle_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'exportation des sous-titres a échoué : ${i?.error}`)
};

const de_subtitle_export_failed_toast = /** @type {(inputs: Subtitle_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Untertitelexport fehlgeschlagen: ${i?.error}`)
};

const it_subtitle_export_failed_toast = /** @type {(inputs: Subtitle_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esportazione sottotitoli fallita: ${i?.error}`)
};

const ru_subtitle_export_failed_toast = /** @type {(inputs: Subtitle_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка экспорта субтитров: ${i?.error}`)
};

const es_subtitle_export_failed_toast = /** @type {(inputs: Subtitle_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error en la exportación de subtítulos: ${i?.error}`)
};

const zh_cn2_subtitle_export_failed_toast = /** @type {(inputs: Subtitle_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`字幕导出失败：${i?.error}`)
};

const ja_subtitle_export_failed_toast = /** @type {(inputs: Subtitle_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`字幕のエクスポートに失敗しました: ${i?.error}`)
};

const hi_subtitle_export_failed_toast = /** @type {(inputs: Subtitle_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`उपशीर्षक निर्यात विफल: ${i?.error}`)
};

const pt_pt2_subtitle_export_failed_toast = /** @type {(inputs: Subtitle_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha na exportação de legendas: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Subtitle export failed: {error}" |
*
* @param {Subtitle_Export_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_failed_toast = /** @type {((inputs: Subtitle_Export_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_failed_toast(inputs)
	if (locale === "de") return de_subtitle_export_failed_toast(inputs)
	if (locale === "it") return it_subtitle_export_failed_toast(inputs)
	if (locale === "ru") return ru_subtitle_export_failed_toast(inputs)
	if (locale === "es") return es_subtitle_export_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_failed_toast(inputs)
	if (locale === "ja") return ja_subtitle_export_failed_toast(inputs)
	if (locale === "hi") return hi_subtitle_export_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_failed_toast(inputs)
	return en_subtitle_export_failed_toast(inputs)
});